module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"time-text":"Expira em: {formattedTime}"},"en-US":{"time-text":"Expires in: {formattedTime}"}}')
  delete Component.options._Ctor
}
